// extracted by mini-css-extract-plugin
export default {"page":"ProductPage_page__RdzPG"};